module.exports = __webpack_public_path__ + "static/media/country_vg.db3dfe89.webp";